"use client"

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      /*
        Sonner hardcodes the description colour per theme — `rgb(63,63,63)`
        light, `rgb(232,232,232)` dark — and picks its theme from
        `prefers-color-scheme`, while the surface below comes from our
        `--popover`. On a dark-mode machine reading a light-only surface those
        disagree, and the description rendered near-white on white. Taking the
        colour from a token instead keeps the two in step whatever sonner
        decides its theme is.
      */
      toastOptions={{ classNames: { description: "!text-muted-foreground" } }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
